import { cn } from "../../../lib/utils";
import { Info } from "lucide-react";
import React, { JSX } from "react";

interface FormElementProps {
    name: string;
    className?: string;
    inputComponent: JSX.Element;
    info?: string;
    isMandatory?: boolean;
    error?: string;
    headerContainerClassName?: string;
    headerRightChildren?: React.ReactNode;
    labelClassName?: string;
}


const FormElement: React.FC<FormElementProps> = ({
    name,
    className,
    isMandatory = true, 
    inputComponent,
    error,
    info,
    headerContainerClassName,
    headerRightChildren,
    labelClassName = ""
}) => {
    return (
        <div className={cn("mb-6", className)}>
            <div className={cn("flex justify-between items-center", headerContainerClassName)}>
                <label htmlFor={name} className={cn("block text-sm font-medium text-gray-700 mb-1", labelClassName)}>
                    {name}
                    {isMandatory && <span className="text-red-500">*</span>}
                </label>
                {headerRightChildren && 
                    <div>
                        {headerRightChildren}
                    </div>
                }
            </div>
            {info && 
                <div className="my-1 flex items-center text-sm text-gray-500">
                    <Info className="h-4 w-4 mr-1" />
                    <span>{info}</span>
                </div>
            }
            
            {inputComponent}
            {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
        </div>
    )
}

export default FormElement;